export const PRESSED_ACTION_BUTTON_CLASS =
  'border-primary/40 bg-accent text-accent-foreground shadow-inner hover:bg-accent/80 dark:bg-accent dark:border-accent-border dark:hover:bg-accent/80 dark:shadow-inner';
